<div class="jumbotron">
    <h1 class="text-center">Report Builder - Metric Reporting</h1>
    <cmps-client-logo></cmps-client-logo>
</div>
<div class="reports-content">
    <ngb-tabset
        activeId="w-tab-report-0"
        #tabSet="ngbTabset"
    >
        <ngb-tab id="w-tab-report-0">
            <ng-template ngbTabTitle>
                <cmps-icon
                    class="legacy:cmps-cdk-fill-green-100"
                    svgIcon="chart-box-outline"
                ></cmps-icon>
                Select Parameters
            </ng-template>
            <ng-template ngbTabContent>
                <div class="p-3">
                    <div
                        cmpsTdBuilderUsageMetricSelectionReport
                        [params]="selectedParams"
                        [peerGroups]="peerGroups"
                        [superGroups]="superGroups"
                        [roles]="roles"
                        [reportPopulations]="reportPopulations"
                        (generated)="onGeneratedReport($event)"
                    ></div>
                </div>
            </ng-template>
        </ngb-tab>
        <ngb-tab id="w-tab-report-1">
            <ng-template ngbTabTitle>
                <cmps-icon
                    class="legacy:cmps-cdk-fill-green-100"
                    svgIcon="file-document"
                ></cmps-icon>
                Metric Report
            </ng-template>
            <ng-template ngbTabContent>
                <div
                    class="p-3"
                    *ngIf="pendingData"
                >
                    <cmps-wait-status></cmps-wait-status>
                    <h2 class="text-center">Report is being generated</h2>
                </div>
                <div
                    class="p-3"
                    *ngIf="!pendingData && noData"
                >
                    <h3 class="text-center">
                        There is no data generated for this report
                    </h3>
                </div>
                <div
                    class="p-3"
                    *ngIf="!pendingData && !noData"
                >
                    <div>
                        <button
                            class="btn-mini"
                            cmpsTooltipTrigger="Refresh"
                            (click)="getReportResult()"
                        >
                            <cmps-icon svgIcon="refresh"></cmps-icon>
                        </button>
                        <button
                            cmpsTooltipTrigger="Export"
                            (click)="onExportClick()"
                            class="btn-mini"
                        >
                            <cmps-icon svgIcon="download"></cmps-icon>
                        </button>
                    </div>

                    Report Population:
                    <b class="f-s-75-2">{{ selectedPopulationType }}</b>
                    <span class="soft-pipe">|</span>
                    Selected: <b class="f-s-75-2">{{ selectedPopulation }}</b>
                    <span class="soft-pipe">|</span>
                    Selected Start Date:
                    <b class="f-s-75-2">{{ params?.startDate }}</b>
                    <span class="soft-pipe">|</span>
                    Selected End Date:
                    <b class="f-s-75-2">{{ params?.endDate }}</b>
                    <span class="soft-pipe">|</span>
                    Generated On:
                    <b class="f-s-75-2">{{ params?.dateRequest }}</b>

                    <div class="table-container mt-3 cmps-reports-table">
                        <table
                            #table
                            class="table"
                        >
                            <tr class="head">
                                <th class="title odd">User Name</th>
                                <th class="title even">Role</th>
                                <th class="title odd">Manager</th>
                                <th class="title even">Super Group</th>
                                <th class="title odd">Metric</th>
                                <th class="title even">Times Generated</th>
                            </tr>
                            <tr *ngFor="let row of data">
                                <td>{{ row.userName }}</td>
                                <td class="text-center">{{ row.role }}</td>
                                <td class="text-center">{{ row.manager }}</td>
                                <td class="text-center">
                                    {{ row.superGroup }}
                                </td>
                                <td class="text-center">{{ row.metric }}</td>
                                <td class="text-center">
                                    {{ row.timesGenerated }}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </ng-template>
        </ngb-tab>
    </ngb-tabset>
</div>
